import { routes } from 'routes/routes';
import { CompassLineIcon, Empty, Link, Search2LineIcon, VideoLineIcon } from 'ui';

type P = {
  isFiltered: boolean;
};

const VideoListEmptyState = ({ isFiltered }: P) => {
  if (isFiltered) {
    return (
      <Empty
        description={{
          subtitle: 'Try adjusting your search or filters',
          title: 'No videos found',
        }}
        image={<Search2LineIcon />}
      />
    );
  }

  return (
    <Empty
      description={{
        subtitle: 'Your videos will appear here',
        title: 'No videos yet',
      }}
      image={<VideoLineIcon />}
    >
      <Link icon={<CompassLineIcon />} to={routes.channels.index}>
        Go to channels
      </Link>
    </Empty>
  );
};

export default VideoListEmptyState;
